document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector("#open-guidelines-modal");
  const insertAfterElement = document.querySelector("#teeFormInputs");
  const theFirstChild = insertAfterElement.firstChild;
  if (elementToMove && insertAfterElement) {
    insertAfterElement.insertBefore(elementToMove, theFirstChild);
  }
  const sizeOption = document.querySelector(".tee-option--size");
  const sizeChartButton = document.createElement("div");
  sizeChartButton.classList = "size-chart-button";
  sizeChartButton.innerHTML = `<span><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.002 512.002" data-inject-url="https://cdn.kiwisizing.com/icons/ruler1.min.svg?v=5-inject2" class="kiwi-svg kiwi-injectable" crossorigin="Anonymous"><path d="M509.502 104.908L407.097 2.502c-3.337-3.337-8.73-3.337-12.067 0L2.502 395.03c-3.337 3.337-3.337 8.73 0 12.067l102.405 102.405c1.596 1.604 3.772 2.5 6.033 2.5s4.43-.896 6.033-2.5L509.5 116.975c1.604-1.596 2.5-3.772 2.5-6.033s-.894-4.43-2.498-6.034zM110.94 491.402l-90.338-90.338 380.46-380.46L491.4 110.94 110.94 491.4zm298.7-414.605c-14.115 0-25.6 11.486-25.6 25.6s11.486 25.6 25.6 25.6 25.6-11.486 25.6-25.6-11.486-25.6-25.6-25.6zm0 34.135c-4.7 0-8.534-3.832-8.534-8.534s3.823-8.534 8.534-8.534 8.534 3.832 8.534 8.534-3.823 8.534-8.534 8.534z"></path><use xlink:href="#B--inject-1"></use><use xlink:href="#C--inject-1"></use><use xlink:href="#B--inject-1" x="-51.203" y="51.195"></use><use xlink:href="#C--inject-1" x="-51.203" y="51.187"></use><use xlink:href="#B--inject-1" x="-102.405" y="102.39"></use><use xlink:href="#C--inject-1" x="-102.405" y="102.383"></use><path d="M164.643 244.95l12.066-12.07 25.6 25.593-12.066 12.07z"></path><use xlink:href="#C--inject-1" x="-153.608" y="153.595"></use><use xlink:href="#B--inject-1" x="-204.81" y="204.796"></use><use xlink:href="#C--inject-1" x="-204.81" y="204.797"></use><use xlink:href="#B--inject-1" x="-255.993" y="256.01"></use><path d="M36.634 372.976l12.068-12.068 34.135 34.135L70.77 407.11z"></path><defs><path id="B--inject-1" d="M318.253 91.37l12.068-12.068 25.603 25.603-12.068 12.068z"></path><path id="C--inject-1" d="M292.648 116.973l12.068-12.068 34.135 34.135-12.068 12.068z"></path></defs></svg><span class="_ks_text">Size Chart</span></span>`;
  if (window?.product?.type == "Sweaters") {
    sizeOption.querySelector(".tee-option__title").append(sizeChartButton);
    sizeChartButton.addEventListener("click", () => {
      document.body.classList.add("vanilla-modal");
      document.body.classList.add("kiwi-sizing-modal-visible");
    });
    document.querySelector(".ks-modal-close").addEventListener("click", () => {
      document.body.classList.remove("vanilla-modal");
      document.body.classList.remove("kiwi-sizing-modal-visible");
    });
    document
      .querySelector(".kiwi-sizing-modal")
      .addEventListener("click", (e) => {
        if (!e.target.closest(".kiwi-sizing-modal-inner")) {
          document.body.classList.remove("vanilla-modal");
          document.body.classList.remove("kiwi-sizing-modal-visible");
        }
      });
    document.querySelectorAll(".ks-unit-toggle-label").forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        var unit = e.currentTarget.dataset.value;
        if (unit == "0") {
          document
            .querySelectorAll('.ks-unit-toggle-label[data-value="0"]')
            .forEach((x) => x.classList.add("kiwi-active"));
          document
            .querySelectorAll('.ks-unit-toggle-label[data-value="1"]')
            .forEach((x) => x.classList.remove("kiwi-active"));
        } else {
          document
            .querySelectorAll('.ks-unit-toggle-label[data-value="1"]')
            .forEach((x) => x.classList.add("kiwi-active"));
          document
            .querySelectorAll('.ks-unit-toggle-label[data-value="0"]')
            .forEach((x) => x.classList.remove("kiwi-active"));
        }
        document
          .querySelectorAll(".ks-table-cell[data-unit-values]")
          .forEach((cell) => {
            let values = JSON.parse(cell.dataset.unitValues);
            cell.innerHTML = unit == "1" ? values[1] : values[0];
          });
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {});

/* Jason - 05162025 */

// const checkSizingChart = () => {
//   var sizingChart = document.querySelector("#openModalBtn");
//   var teeOptionTitle = document.querySelector(
//     ".tee-option--size .tee-option__title"
//   );
//   if (sizingChart && teeOptionTitle) {
//     var existingClone = teeOptionTitle.querySelector("#openModalBtn");
//     if (!existingClone) {
//       var sizingChartClone = sizingChart.cloneNode(true);
//       teeOptionTitle.appendChild(sizingChartClone);
//       sizingChartClone.addEventListener("click", function () {
//         sizingChart.click();
//       });
//     }
//   }
// };
// document.addEventListener("teeinblue-event-variant-changed", checkSizingChart);
// document.addEventListener("teeinblue-event-component-injected", () => {
//   const checkElementRendered = setInterval(() => {
//     if (document.querySelector("#openModalBtn")) {
//       checkSizingChart();
//       clearInterval(checkElementRendered);
//     }
//   }, 1000);
//   document
//     .querySelectorAll(".tee-available-products .tee-radio")
//     .forEach((radio) => {
//       radio.addEventListener("click", () => {
//         setTimeout(() => {
//           checkSizingChart();
//         }, 200);
//       });
//     });
// });

/* Jason - 05162025 */

const checkSizingChart2 = () => {
  var sizingChart = document.querySelector(".ks-chart-modal-link");
  console.log("sizingChart", sizingChart);
  var teeOptionTitle = document.querySelector(
    ".tee-option--size .tee-option__title"
  );
  const span = document.createElement("span");
  span.textContent = "* Find Your Best Fit →";
  span.style.color = "#6b96fa";
  if (sizingChart && teeOptionTitle) {
    var existingClone = teeOptionTitle.querySelector(".ks-chart-modal-link");
    if (!existingClone) {
      if (teeOptionTitle.children.length >= 1) {
        teeOptionTitle.insertBefore(span, teeOptionTitle.children[1]);
      } else {
        // Nếu chưa có con nào, thêm vào cuối cùng
        teeOptionTitle.appendChild(span);
      }
      var sizingChartClone = sizingChart.cloneNode(true);
      teeOptionTitle.appendChild(sizingChartClone);
      sizingChart.style.display = "none";
      sizingChartClone.addEventListener("click", function () {
        console.log("heni", sizingChart);
        sizingChart.click();
      });
    }
  }
};
document.addEventListener("teeinblue-event-variant-changed", checkSizingChart2);
document.addEventListener("teeinblue-event-component-injected", () => {
  const checkElementRendered = setInterval(() => {
    if (document.querySelector(".ks-chart-modal-link")) {
      checkSizingChart2();
      clearInterval(checkElementRendered);
    }
  }, 1000);
  document
    .querySelectorAll(".tee-available-products .tee-radio")
    .forEach((radio) => {
      radio.addEventListener("click", () => {
        setTimeout(() => {
          checkSizingChart();
        }, 200);
      });
    });
});
